import { connect } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import {
  Table, TableContainer, TableHead, TableBody, TableRow, TableCell,
  Typography, Button, TablePagination, Box, Paper, Modal, IconButton,
  TextField, FormControl, Select, InputLabel, MenuItem, CircularProgress,
  Autocomplete
} from "@mui/material";
import * as Action from "../../actions/adminAction";
import Stack from "@mui/material/Stack";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useMemo } from "react";
import moment from "moment";
import dayjs from "dayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { BASE_URL } from '../../utils/urls';

export const UploadTraningDocslist = ({
  getDistrictWiseTalukaData,
  getQualitycheckerDistrictData,
  userDetails,
  getTalukaWisePanchayat,
  getAllTrainingModuleData,
  FinalAprroveTraining,
  setActiveList,
  getDistrictWiseTrainingList
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);

  // data variables
  const [city, setCity] = useState("");
  const [taluka, setTaluka] = useState("");
  const [panchayat, setPanchayat] = useState("");
  const [trainerData, setTrainerData] = useState([]);
  const [type, setType] = useState("");
  const [ModuleData, setModuleData] = useState([]);
  const [searchTrainer, setsearchTrainer] = useState(null);
  const [userData, setuserData] = useState([]);

  // error variables
  const [cityError, setcityError] = useState(false);
  const [TalukaError, setTalukaError] = useState(false);
  const [PanchayatError, setPanchayatError] = useState(false);
  const [typeError, setTypeError] = useState(false);
  const [TalukaData, setTalukaData] = useState([]);
  const [DistrictData, setDistrictData] = useState([]);
  const [GrampanchayatData, setGrampanchayatData] = useState([]);

  // pagination
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [FinalApproveEvidenceId, setFinalApproveEvidenceId] = useState('');
  const [FinalApproveModuleId, setFinalApproveModuleId] = useState('');
  const [FinalApproveDistrictId, setFinalApproveDistrictId] = useState('');
  const [FinalApprovePanchayatId, setFinalApprovePanchayatId] = useState('');
  const [openFinal, setopenFinal] = useState(false);

  // date filter
  const [startDate, setstartDate] = useState(dayjs().startOf("month"));
  const [endDate, setendDate] = useState(dayjs());
  const [dateError, setdateError] = useState(false);
  const [InvalidDate, setInvalidDate] = useState(false);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // 🔥 FIX: Filter logic for Trainer/Regional Coordinator
  const filteredTrainerData = useMemo(() => {
    if (!searchTrainer) return trainerData;

    // Construct search string (e.g., "John Doe")
    const searchName = `${searchTrainer?.firstName || ""} ${searchTrainer?.lastName || ""}`.toLowerCase().trim();
    if (!searchName) return trainerData;

    return trainerData.filter((row) => {
      const trainerNames = row?.trainerNameAll || [];
      // Ensure it's an array (in case backend returns a single string sometimes)
      const namesArray = Array.isArray(trainerNames) ? trainerNames : [trainerNames];

      // Check if any of the trainers in the row match the search
      return namesArray.some(name =>
        (name || "").toLowerCase().includes(searchName)
      );
    });
  }, [trainerData, searchTrainer]);

  // ---------- Dropdown loaders ----------
  const getDistrict = async () => {
    const result = await getQualitycheckerDistrictData({ user_id: userDetails?._id });
    if (result && result !== "No data found") {
      setDistrictData(result);
    } else {
      setDistrictData([]);
    }
  };

  const getTaluka = async () => {
    setTalukaError(false);
    const result = await getDistrictWiseTalukaData({ distric_id: city?._id });
    if (result && result !== 'No data found') {
      setTalukaData(result);
    } else {
      setTalukaError(true);
      setTalukaData([]);
    }
  };

  const getPanchayat = async () => {
    setPanchayatError(false);
    const result = await getTalukaWisePanchayat({
      distric_id: city?._id,
      taluka_id: taluka?._id
    });
    if (result && result !== 'No data found') {
      setGrampanchayatData(result);
    } else {
      setPanchayatError(true);
      setGrampanchayatData([]);
    }
  };

  const getModule = async () => {
    const result = await getAllTrainingModuleData();
    if (result && result !== 'No data found') {
      setModuleData(result);
    } else {
      setModuleData([]);
    }
  };

  useEffect(() => {
    getDistrict();
    getModule();
    AllUplodedTrainerData();
  }, []);

  useEffect(() => {
    // reset dependent dropdowns when parent changes
    setTaluka("");
    setTalukaData([]);
    if (city) getTaluka();
  }, [city]);

  useEffect(() => {
    setPanchayat("");
    setGrampanchayatData([]);
    if (taluka) getPanchayat();
  }, [taluka]);

  // ---------- MAIN DATA FETCH (uses districtwiselist API) ----------
  const AllUplodedTrainerData = async () => {
    setLoader(true);
    try {
      const result = await getDistrictWiseTrainingList({
        distric_id: userDetails?.assignDistrict_id,
        startDate: startDate.format("YYYY-MM-DD"),
        endDate: endDate.format("YYYY-MM-DD")
      });
      if (result && result !== 'No data found') {
        setTrainerData(result);
      } else {
        setTrainerData([]);
      }
    } catch (e) {
      console.error(e);
      setTrainerData([]);
    } finally {
      setLoader(false);
    }
  };

  // "Get Data" — uses SAME API as table, with all dropdown filters
  const getFilteredData = async () => {
    // validate
    const cErr = !city;
    const tErr = !taluka;
    const pErr = !panchayat;
    const tyErr = !type;
    setcityError(cErr);
    setTalukaError(tErr);
    setPanchayatError(pErr);
    setTypeError(tyErr);

    if (cErr || tErr || pErr || tyErr) return;

    setLoader(true);
    try {
      const payload = {
        distric_id: city?._id,
        taluka_id: taluka?._id,
        grampanchayat_id: panchayat?.schoolId,
        trainingModule_id: type?._id,
        startDate: startDate.format("YYYY-MM-DD"),
        endDate: endDate.format("YYYY-MM-DD")
      };
      // remove any undefined just in case
      Object.keys(payload).forEach(k => payload[k] === undefined && delete payload[k]);

      const result = await getDistrictWiseTrainingList(payload);
      if (result && result !== 'No data found') {
        setTrainerData(result);
      } else {
        setTrainerData([]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoader(false);
    }
  };

  const getDateWise = async () => {
    setLoader(true);
    setdateError(false);
    setInvalidDate(false);

    if (!startDate?.isValid() || !endDate?.isValid()) {
      setLoader(false);
      setdateError(true);
      return;
    }

    if (endDate.isBefore(startDate, 'day')) {
      setLoader(false);
      setInvalidDate(true);
      return;
    }

    try {
      const result = await getDistrictWiseTrainingList({
        // distric_id: userDetails?.assignDistrict_id,
        distric_id: city?._id || userDetails?.assignDistrict_id,
        taluka_id: taluka?._id,
        grampanchayat_id: panchayat?.schoolId,
        trainingModule_id: type?._id,
        startDate: startDate.format("YYYY-MM-DD"),
        endDate: endDate.format("YYYY-MM-DD")
      });
      if (result && result !== 'No data found') {
        setTrainerData(result);
      } else {
        setTrainerData([]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoader(false);
    }
  };

  const FinalAprroveTrainingData = async () => {
    const result = await FinalAprroveTraining({
      trainingsssigntrainers_id: FinalApproveEvidenceId,
      trainingModule_id: FinalApproveModuleId,
      distric_id: FinalApproveDistrictId,
      grampanchayat_id: FinalApprovePanchayatId,
      updatedBy: userDetails?._id
    });
    if (result) {
      AllUplodedTrainerData();
      navigate("/QualityChecker/Approved-document");
      setActiveList("/QualityChecker/Approved-document");
    }
  };

  const openFinalApproval = (row) => {
    setFinalApproveEvidenceId(row?._id);
    setFinalApproveDistrictId(row?.distric_id);
    setFinalApprovePanchayatId(row?.grampanchayat_id);
    setFinalApproveModuleId(row?.trainingModule_id);
    setopenFinal(true);
  };

  // 🆕 Local function to fetch regional trainers directly via fetch
  const fetchRegionalTrainers = async () => {
    try {
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      // Fix: append array values properly
      ["trainer", "regional_coordinator"].forEach((type) => {
        urlencoded.append("userType", type);
      });

      let requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: urlencoded,
        redirect: "follow",
      };

      const response = await fetch(BASE_URL + "/user/getuserlist", requestOptions);
      const result = await response.json();

      // Safely extract the array
      if (Array.isArray(result)) {
        setuserData(result);
      } else if (result && Array.isArray(result.Data)) {
        setuserData(result.Data);
      } else if (result && Array.isArray(result.data)) {
        setuserData(result.data);
      } else {
        setuserData([]);
      }
    } catch (error) {
      console.error("Error fetching regional trainers:", error);
      setuserData([]);
    }
  };

  useEffect(() => {
    fetchRegionalTrainers()
  }, [])

  return (
    <div className={classes.main}>
      <center>
        <Typography style={{ margin: 20, fontSize: 30, fontWeight: 600 }}>
          Upload Training Document
        </Typography>
      </center>

      <div style={{
        display: 'flex', flexDirection: 'row', justifyContent: 'start',
        alignItems: 'center', flexWrap: "wrap", marginBottom: 50
      }}>
        {/* District */}
        <FormControl sx={{ m: 1, marginRight: 3 }}>
          <InputLabel>District</InputLabel>
          <Select style={{ width: 250 }} label="District" value={city}
            onChange={(e) => setCity(e.target.value)}
            MenuProps={{ style: { maxHeight: 400 } }}>
            {DistrictData?.map((item) => (
              <MenuItem key={item?._id} value={item}>{item?.districtName}</MenuItem>
            ))}
          </Select>
          {cityError && <span style={{ color: "red", fontSize: 15 }}>*Please Select District</span>}
        </FormControl>

        {/* Taluka */}
        <FormControl sx={{ m: 1, marginRight: 3 }}>
          <InputLabel>Taluka</InputLabel>
          <Select style={{ width: 250 }} label="Taluka" value={taluka}
            onChange={(e) => setTaluka(e.target.value)}
            MenuProps={{ style: { maxHeight: 400 } }}>
            {TalukaData?.map((item) => (
              <MenuItem key={item?._id} value={item}>{item?.talukaName}</MenuItem>
            ))}
          </Select>
          {TalukaError && <span style={{ color: "red", fontSize: 15 }}>*Please Select Taluka</span>}
        </FormControl>

        {/* School */}
        <FormControl sx={{ m: 1, marginRight: 3 }}>
          <InputLabel>School</InputLabel>
          <Select style={{ width: 250 }} label="School" value={panchayat}
            onChange={(e) => setPanchayat(e.target.value)}
            MenuProps={{ style: { maxHeight: 400 } }}>
            {GrampanchayatData?.map((item) => (
              <MenuItem key={item?._id} value={item}>{item?.schoolName}</MenuItem>
            ))}
          </Select>
          {PanchayatError && <span style={{ color: "red", fontSize: 15 }}>*Please Select School</span>}
        </FormControl>

        {/* Module */}
        <FormControl sx={{ m: 1, marginRight: 3 }}>
          <InputLabel>Module</InputLabel>
          <Select style={{ width: 250 }} label="Module" value={type}
            onChange={(e) => setType(e.target.value)}
            MenuProps={{ style: { maxHeight: 400 } }}>
            {ModuleData?.map((item) => (
              <MenuItem key={item?._id} value={item}>{item?.trainingModuleName}</MenuItem>
            ))}
          </Select>
          {typeError && <span style={{ color: "red", fontSize: 15 }}>*Please Select Module</span>}
        </FormControl>

        <Button sx={{ m: 1, marginRight: 3 }} variant="contained"
          style={{ fontSize: 14 }} onClick={getFilteredData}>
          Get Data
        </Button>

        <Button sx={{ m: 1, marginRight: 3 }} variant="contained"
          style={{ marginLeft: 3, fontSize: 14 }} onClick={() => {
            AllUplodedTrainerData()
            setCity("")
            setType("")
            setTaluka("")
            setPanchayat("")
            setsearchTrainer(null) // 🔥 FIX: Reset Trainer Search too
          }}>
          {loader ? <CircularProgress color='primary' size={20} /> : 'Reset'}
        </Button>
      </div>

      {/* Date Filter */}
      <Box style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: 15, marginBottom: 20 }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Start Date"
              value={startDate}
              onChange={(newValue) => setstartDate(newValue)}
              format="DD/MM/YYYY"
              renderInput={(params) => <TextField sx={{ width: 150 }} {...params} />}
            />
          </LocalizationProvider>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="End Date"
              value={endDate}
              minDate={startDate}
              onChange={(newValue) => setendDate(newValue)}
              format="DD/MM/YYYY"
              renderInput={(params) => <TextField sx={{ width: 150 }} {...params} />}
            />
          </LocalizationProvider>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Button variant='contained' style={{ width: 170, height: 50 }}
            onClick={getDateWise}>Get Data Datewise</Button>
          {dateError && <span style={{ color: 'red' }}>*Please Select Both Dates</span>}
          {InvalidDate && <span style={{ color: 'red' }}>*End Date cannot be less than Start date</span>}
        </div>

        {/* trainer and rc filter by name */}
        <div>
          <Autocomplete
            id="Trainer-data"
            sx={{ width: 350 }}
            options={Array.isArray(userData) ? userData : []}
            autoHighlight
            disablePortal
            freeSolo
            value={searchTrainer}
            disabled={!userData || userData.length === 0}
            getOptionLabel={(option) =>
              option?.firstName
                ? `${option?.firstName} ${option?.lastName || ""} - ${option?.contactNo || ""}`
                : ""
            }
            renderInput={(params) => (
              <TextField {...params} label="Search By Trainer or Regional Coordinator" />
            )}
            onChange={(event, newValue) => {
              setsearchTrainer(newValue);
              setPage(0); // 🔥 FIX: Reset pagination on new search
            }}
          />
        </div>
      </Box>

      {loader ? <CircularProgress color="primary" /> : (
        <Paper sx={{ overflow: "hidden", width: "90%" }}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  {["SR No.", "Name", "District", "School", "Training Module",
                    "Training Start Date", "Training Timing",
                    "Documents Uploaded", "Action"].map(h => (
                      <TableCell key={h} style={{ fontSize: 16, textAlign: "center" }}>
                        <strong>{h}</strong>
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {/* 🔥 FIX: Changed trainerData to filteredTrainerData */}
                {Array.isArray(filteredTrainerData) && filteredTrainerData.length > 0 ? (
                  filteredTrainerData
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => (
                      <TableRow key={row?._id || index}>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>{index + 1}</TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {row?.trainerNameAll?.[0] || '-'}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>{row?.districtName}</TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>{row?.grampanchayatName}</TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>{row?.trainingModuleName}</TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {moment(row?.startDate).format("DD MMM YYYY")}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          {row?.shift?.toUpperCase()}
                        </TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>{row?.docUploadedCount}</TableCell>
                        <TableCell style={{ fontSize: 16, textAlign: "center" }}>
                          <Button variant="contained" style={{ margin: 5 }}
                            onClick={() => navigate("/QualityChecker/view-trainer-docs", { state: row })}>
                            Verify Document
                          </Button>
                          <Button variant="contained" style={{ margin: 5 }}
                            onClick={() => openFinalApproval(row)}
                            disabled={!row?.approvalEligibility}>
                            Final Approval
                          </Button>
                        </TableCell>
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={9} align="center">No Data Found</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={filteredTrainerData?.length || 0} // 🔥 FIX: Updated count to use filteredData
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}

      <Modal className={classes.middlePosition} open={openFinal}
        onClose={(e) => { e.preventDefault(); setopenFinal(false); }}>
        <Paper className={classes.passmodal}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2}>
            <Typography variant='h6'>Want to Approve this Training</Typography>
            <IconButton onClick={e => { e.preventDefault(); setopenFinal(false); }}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <div style={{
            display: 'flex', justifyContent: 'center', flexDirection: 'column',
            alignItems: 'center', marginTop: 10
          }}>
            <h3>Do you want to Approve this Training ?</h3>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <Button variant="contained"
                style={{ backgroundColor: 'green', width: 100, margin: 5 }}
                onClick={() => { setopenFinal(false); FinalAprroveTrainingData(); }}>Approve</Button>
              <Button variant="contained"
                style={{ backgroundColor: 'grey', width: 100, margin: 5 }}
                onClick={() => setopenFinal(false)}>Cancel</Button>
            </div>
          </div>
        </Paper>
      </Modal>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  main: {
    display: "flex", alignItems: "center", justifyContent: "center",
    flexDirection: "column", marginTop: 30, flexWrap: 'wrap'
  },
  passmodal: {
    width: "350px", background: "white", borderRadius: "20px !important",
    margin: "20px", padding: "20px"
  },
  middlePosition: {
    display: "flex", alignItems: "center", justifyContent: "center"
  }
}));

const mapStateToProps = (state) => ({
  userDetails: state.auth.userDetails
});

const mapDispatchToProps = (dispatch) => ({
  getDistrictWiseTalukaData: (data) => dispatch(Action.getDistrictWiseTalukaData(data)),
  getTalukaWisePanchayat: (data) => dispatch(Action.getTalukaWisePanchayat(data)),
  getAllTrainingModuleData: () => dispatch(Action.getAllTrainingModuleData()),
  getQualitycheckerDistrictData: (data) => dispatch(Action.getQualitycheckerDistrictData(data)),
  FinalAprroveTraining: (data) => dispatch(Action.FinalAprroveTraining(data)),
  setActiveList: (data) => dispatch(Action.setActiveList(data)),
  getDistrictWiseTrainingList: (data) => dispatch(Action.getDistrictWiseTrainingList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadTraningDocslist);